import Counter from "@components/counter/layout-01";
import { Container } from "@ui/wrapper";
import { ItemType } from "@utils/types";
import PropTypes from "prop-types";
import React from "react";
import { Grid, GridWrap, SectionWrap } from "./style";

const FunFactArea = ({ data }) => {
    return (
        <SectionWrap>
            <Container>
                <GridWrap>
                    {data?.items?.map((item) => (
                        <Grid key={item.id}>
                            <Counter
                                className="fun-fact-area-01__counter-item"
                                title={item.title}
                                countTo={item.count}
                                text={item.description}
                            />
                        </Grid>
                    ))}
                </GridWrap>
            </Container>
        </SectionWrap>
    );
};

FunFactArea.propTypes = {
    data: PropTypes.shape({
        items: PropTypes.arrayOf(PropTypes.shape(ItemType)),
    }),
};

export default FunFactArea;
